(function () {
    'use strict';

    angular
        .module('app')
        .controller('TermsController', TermsController);

    TermsController.$inject = ['$rootScope'];

    function TermsController($rootScope) {
        var TermsCtrl = this;
        TermsCtrl.$onInit = init;


        function init() {
            $rootScope.header_inverted = true;
        }

    }
})();